<template>
  <int-order :detail="detail" :statusEnum="statusEnum"></int-order>
</template>

<script>
import intOrder from "@/views/order/intOrder";
import { getOrderDetail } from "@/api/order";
import { statusEnum } from "./enum";
export default {
  components: { intOrder },
  props: {
    id: {
      type: String
    }
  },
  data() {
    return {
      detail: null,
      statusEnum
    };
  },
  created() {
    this.fetchDetail();
  },
  methods: {
    fetchDetail() {
      getOrderDetail({ id: this.id }).then(res => {
        this.detail = res;
      });
    }
  }
};
</script>

<style lang="less" scoped>
.info-body {
  padding: 20px 30px;
}
.order {
  &-status {
    &-wait {
      color: #ff3600;
    }
  }
  &-header {
    display: flex;
  }
}
.oil {
  &-list-item {
    margin-top: 20px;
    padding: 20px 30px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 3px 7px 0px rgba(186, 210, 234, 0.3);
    border-radius: 14px;
    display: flex;
  }
  &-logo {
    flex: none;
    margin-right: 30px;
    img {
      display: block;
      height: 140px;
      width: 140px;
    }
  }
  &-detail {
    flex: 1;
    display: flex;
    justify-content: space-between;
    flex-flow: column;
    &-title {
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 1em;
      color: rgba(17, 17, 17, 1);
    }
    &-spec {
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: 400;
      color: rgba(145, 145, 145, 1);
    }
    &-extra {
      display: flex;
      justify-content: space-between;
      line-height: 1em;
    }
    &-total {
      &-prefix {
        color: #535353;
        font-size: 12px;
      }
      color: #ff3600;
      font-size: 15px;
    }
    &-price {
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #525252;
    }
    &-action {
      width: 50px;
      height: 50px;
      background: rgba(246, 246, 246, 1);
      border-radius: 50%;
      text-align: center;
      line-height: 50px;
    }
  }
}
</style>
